export async function dynamicReduce(param, data, type) {
    let res;
    await data.reduce((acumulador, objeto) => {
        const area = objeto[param];
        if (!acumulador[area]) {
            acumulador[area] = [];
        }
        acumulador[area].push(objeto);
        res = acumulador;
        return acumulador;
    }, type);
    return res;
}
